import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=39a697da&scoped=true&"
import script from "./app-aside.vue?vue&type=script&lang=js&"
export * from "./app-aside.vue?vue&type=script&lang=js&"
import style0 from "./app-aside.vue?vue&type=style&index=0&id=39a697da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a697da",
  null
  
)

export default component.exports